import { render, staticRenderFns } from "./IconWoocommerce.vue?vue&type=template&id=37f9ba6c"
import script from "./IconWoocommerce.vue?vue&type=script&lang=js"
export * from "./IconWoocommerce.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports